import { Button } from '@material-ui/core';

import { useMenuTabs } from './hooks';

import makeClasses from './MenuTabs.style';

export type MenuTab = 'novelties' | 'complaints';

export function MenuTabs(props: Props) {
  const {
    showTab,
    numberOfNotSeen,
    menuTabSelected,
    onSelectNovelties,
    onSelectComplaints,
  } = props;

  const { lang } = useMenuTabs();

  const tabs: Tabs = (['complaints', 'novelties'] as MenuTab[]).map(tType => ({
    type: tType,
    visible: showTab[tType],
    title: lang[tType].title,
    count: numberOfNotSeen[tType],
    description: lang[tType].description,
    onSelect: tType === 'complaints' ? onSelectComplaints : onSelectNovelties,
  }));

  const _classes = makeClasses();

  return (
    <menu className={_classes.menu}>
      {tabs
        .filter(tab => tab.visible)
        .map(tab => (
          <li key={tab.type} className={_classes.tab}>
            <Button
              fullWidth
              onClick={tab.onSelect}
              aria-selected={menuTabSelected === tab.type}
              classes={{
                root: _classes.tabBtnRoot,
                label: _classes.tabBtnLabel,
              }}
            >
              <h2 className={_classes.title}>
                {tab.title}
                <span
                  hidden={tab.count === 0}
                  className={_classes.listOfLength}
                >
                  {tab.count}
                </span>
              </h2>
              <p className={_classes.description}>{tab.description}</p>
            </Button>
          </li>
        ))}
    </menu>
  );
}

interface Props {
  showTab: {
    novelties: boolean;
    complaints: boolean;
  };
  numberOfNotSeen: {
    novelties: number;
    complaints: number;
  };
  menuTabSelected: MenuTab;
  onSelectNovelties: () => void;
  onSelectComplaints: () => void;
}

type Tabs = Array<{
  type: MenuTab;
  visible: boolean;
  onSelect: () => void;
  title: string;
  count: number;
  description: string;
}>;
